import { render, staticRenderFns } from "./FeVegeta.vue?vue&type=template&id=331548e0&"
import script from "./FeVegeta.vue?vue&type=script&lang=js&"
export * from "./FeVegeta.vue?vue&type=script&lang=js&"
import style0 from "./FeVegeta.vue?vue&type=style&index=0&id=331548e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports